import React from "react";
import { TableContentForManualLeafReport } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const columnNames = this.props.columnNames;
        const footerData = this.props.footerData;

        return (
            <div>
                <h3><center><u>Daily Leaf Collection Manual Leaf Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route === undefined ? "All Routes" : searchData.route}</div>
                    <div className="col"><b>Leaf Collected Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>Day End: </b> {searchData.toDate}</div>
                </div>
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <table id="routeWiseCropDetails" className="display dataTable no-footer" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        {columnNames.map((x, index) => {
                                            var align = (x === "Reg. Number" || x === "Reg. Name") ? "left" : "right";
                                            return (
                                                <th style={{ textAlign: align }} key={index}>{x}</th>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContentForManualLeafReport
                                        data={reportData}
                                        contentRowNames={contentRowNames}
                                        hasEdit={false}
                                    />
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={2}>Total</th>
                                        {contentRowNames.map(x => {
                                            var equalRecode = footerData.find(y => y.name.toString() === x.toString())
                                            if (x !== "regNo" && x !== "name") {
                                                return (
                                                    <th style={{ textAlign: "right" }}>{equalRecode.value.toFixed(2)}</th>
                                                );
                                            }
                                        })}
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}